export class BmfApiError extends Error {
  constructor(options?: { cause?: any }) {
    super('An error occurred while requesting the BMF API', options)
  }
}
